// import { useQuery } from "@tanstack/react-query";
// import { useSelectedPlanContext } from "../contexts/SelectedPlanContext";

// const useFetchRestrictedIds = (rackId, bandwidthId, energyId, prefixId) => {
// 	// Check if all values in selectedOptions are defined
// 	const { selectedPlan } = useSelectedPlanContext();
// 	const runQuery = !!rackId && !!bandwidthId && !!energyId && !!prefixId && !!selectedPlan;

// 	const fetchRestrictedIds = async () => {
// 		// If any of the values in selectedOptions is undefined, return an empty array and dont run the query.
// 		if (!runQuery) {
// 			return [];
// 		}
// 		try {
// 			const url = `${process.env.GATSBY_RESTRICTIONS_ENDPOINT}&bandwidthId=${bandwidthId}&rackId=${rackId}&energyId=${energyId}&prefixId=${prefixId}`;
// 			const response = await fetch(url);

// 			if (!response.ok) {
// 				throw new Error("Failed to fetch restricted ids data");
// 			}

// 			const data = await response.json();
// 			// Extract restricted IDs from the response
// 			const restrictedIds = {
// 				bandwidths: data.bandwidths.map((item) => item),
// 				rack: data.racks.map((item) => item),
// 				energy: data.energies.map((item) => item),
// 				prefix: data.prefixes.map((item) => item),
// 			};
// 			const idArray = Object.values(restrictedIds).reduce((acc, current) => acc.concat(current), []);
// 			return idArray; // Return the restricted IDs
// 		} catch (error) {
// 			throw new Error("Failed to fetch restricted IDs");
// 		}
// 	};

// 	return useQuery({
// 		queryKey: ["restrictedIds", rackId, energyId, bandwidthId, prefixId], // Refetch query when the rack options change only (Expand for extra restrictions)
// 		queryFn: fetchRestrictedIds,
// 		refetchOnWindowFocus: false,
// 		keepPreviousData: true, // Prevent UI flicker by retaining data
// 		enabled: runQuery, // Enable the query only if all values in selectedOptions are defined
// 	});
// };

// export default useFetchRestrictedIds;

import { useQuery } from "@tanstack/react-query";
import { useSelectedPlanContext } from "../contexts/SelectedPlanContext";

const useFetchColoRestrictedIds = (rackId, bandwidthId, energyId, prefixId) => {
	// Check if all values in selectedOptions are defined
	const { selectedPlan } = useSelectedPlanContext();
	const runQuery = !!rackId && !!bandwidthId && !!energyId && !!prefixId && !!selectedPlan;

	const fetchRestrictedIds = async () => {
		// If any of the values in selectedOptions is undefined, return an empty array and dont run the query.
		if (!runQuery) {
			return [];
		}
		try {
			const url = `${process.env.GATSBY_RESTRICTIONS_ENDPOINT}&bandwidthId=${bandwidthId}&rackId=${rackId}&energyId=${energyId}&prefixId=${prefixId}`;
			const response = await fetch(url);

			if (!response.ok) {
				throw new Error("Failed to fetch restricted ids data");
			}

			const data = await response.json();
			// Extract restricted IDs from the response
			const restrictedIds = {
				bandwidths: data.bandwidths.map((item) => item),
				rack: data.racks.map((item) => item),
				energy: data.energies.map((item) => item),
				prefix: data.prefixes.map((item) => item),
			};
			const idArray = Object.values(restrictedIds).reduce((acc, current) => acc.concat(current), []);
			return idArray; // Return the restricted IDs
		} catch (error) {
			throw new Error("Failed to fetch restricted IDs");
		}
	};

	return useQuery({
		queryKey: ["restrictedIds", rackId, energyId, bandwidthId, prefixId], // Refetch query when the rack options change only (Expand for extra restrictions)
		queryFn: fetchRestrictedIds,
		refetchOnWindowFocus: false,
		keepPreviousData: true, // Prevent UI flicker by retaining data
		enabled: runQuery, // Enable the query only if all values in selectedOptions are defined
	});
};

export default useFetchColoRestrictedIds;
